import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Input,
  Tooltip,
  Whisper,
  Stack,
  IconButton,
  InputGroup,
  Form,
  Message,
  Table,
  SelectPicker,
  toaster
} from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import useTableHeight from '@/components/useTableHeight';
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import WarningRoundIcon from '@rsuite/icons/WarningRound';
import { ReviewPass } from '@rsuite/icons';
import { Popconfirm } from 'antd';

interface RowDataComp {
  id: string; // or number, depending on your data
  attributes: {
    CompName: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const CompNameMaster = () => {
  const { Cell } = Table;
  const { tableHeight, tableHeight2 } = useTableHeight();
  const data = ['Continue', 'Discontinue', 'All'].map(item => ({ label: item, value: item }));

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  ////////////////  Function Component Start /////////////////

  const [component, setComponent] = useState({
    CompName: '',
    dis: 'Continue'
  });
  // Fetch Data from API Start
  const [compdata, setCompdata] = useState<RowDataComp[]>([]);
  const [compmeta, setCompmeta] = useState<MetaData>();
  const [editedRowIdsComp, setEditedRowIdsComp] = useState<string[]>([]);
  const [editedRowIdComp, setEditedRowIdComp] = useState<string>('');
  const [editedDataComp, setEditedDataComp] = useState<
    Record<string, Partial<RowDataComp['attributes']>>
  >({});
  const [selectedBuyercomp, setSelectedBuyercomp] = useState('Continue');
  const handleBuyerChangecomp = value => {
    setSelectedBuyercomp(value);
  };
  const [isLoading13, setIsLoading13] = useState(false);
  const [disMSTCom, setDisMSTCom] = useState([]);
  ////////////////  Searching For 13 Start /////////////////
  const [searchQuery13, setSearchQuery13] = useState('');
  const [filterStatus11, setFilteredStatus11] = useState('Continue');
  const handleSearch13 = value => {
    setSearchQuery13(value);
  };

  ////////////////  Searching For 13 End /////////////////
  useEffect(() => {
    fetchDatacomp();
  }, [selectedBuyercomp]);
  const fetchDatacomp = async () => {
    if (isLoading13) {
      return;
    }
    setIsLoading13(true);
    let disFilter = '';
    if (selectedBuyercomp.length > 0) {
      disFilter = `&filters[dis][$eq]=${selectedBuyercomp}`;
    }
    if (selectedBuyercomp == 'All') {
      disFilter = '';
    }
    const pageResponse = await fetch(
      `${globalIP}/api/mst-components?populate=*&pagination[page]=1&sort[0]=id${disFilter}`
    );
    const pageJson = await pageResponse.json();
    const allData = [];
    for (let page = 1; page <= pageJson.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mst-components?populate=*&pagination[page]=${page}&sort[0]=id${disFilter}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    const responseformeta = await fetch(
      `${globalIP}/api/mst-components?populate=*&publicationState=preview`
    );
    const jsonmeta = await responseformeta.json();

    const response2 = await fetch(`${globalIP}/api/mst-components`);
    const pageJson2 = await response2.json();
    const allData2 = [];
    for (let page = 1; page <= pageJson2.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mst-components?populate=*&pagination[page]=${page}`
      );
      const pageJson2 = await pageResponse.json();
      allData2.push(...pageJson2.data);
    }
    setDisMSTCom(allData2);
    setCompmeta(jsonmeta.meta);
    setCompdata(allData);
    setIsLoading13(false);
  };
  const [componentFilterData, setComponentFilterData] = useState([]);

  useEffect(() => {
    const componentFilterData = compdata
      .slice()
      .reverse()
      .filter(item => {
        const ColorName = item.attributes.CompName ? item.attributes.CompName.toLowerCase() : '';
        return ColorName.includes(searchQuery13.toLowerCase());
      });
    setComponentFilterData(componentFilterData);
  }, [compdata, filterStatus11, searchQuery13]);
  const processInputRef = useRef(null);
  const handleEditRowComp = rowData => {
    setComponent({ ...rowData.attributes });
    setEditedRowIdComp(rowData.id);
    setEditedRowIdsComp(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDataComp(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
    if (processInputRef.current) {
      processInputRef.current.focus();
    }
  };

  const resetComponent = () => {
    setComponent({
      CompName: '',
      dis: 'Continue'
    });
  };
  const handleCancelComponent = rowData => {
    resetComponent();
    setEditedRowIdComp('');
    setEditedRowIdsComp('');
  };
  const url13 = `${globalIP}/api/mst-components`;
  const submit13 = async e => {
    const trimmedColorName = component.CompName?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

    if (trimmedColorName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Component Name.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (specialCharPattern.test(trimmedColorName)) {
      toaster.push(
        <Message showIcon type="error">
          Component Name should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      const { data: comName } = await axios.get(
        `${globalIP}/api/mst-components?filters[CompName][$eqi]=${trimmedColorName}`
      );
      try {
        const existingColor = disMSTCom.find(
          item => item.attributes.CompName.toLowerCase() === trimmedColorName.toLowerCase()
        );

        if (comName.data.length) {
          toaster.push(
            <Message showIcon type="warning">
              Component Name already exists.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          e.preventDefault();
          const formData = new FormData();
          formData.append('data', JSON.stringify({ ...component, CompName: trimmedColorName }));

          const response = await fetch(url13, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            await fetchDatacomp();
            console.log(component);

            toaster.push(
              <Message showIcon type="success">
                Data Saved Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error('Error occurred while saving data', error);
      }

      setComponent({
        CompName: '',
        dis: 'Continue'
      });
    }
  };

  //  Fetch Data from API End
  const handleInputChangecomp = (inputName, value, index) => {
    setComponent({ ...component, [inputName]: value });
  };
  const handleCompC = async (catalogId, ColorName) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...compdata,
        dis: 'Continue'
      })
    );
    fetch(`${globalIP}/api/mst-components/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchDatacomp();

        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleCompD = async (catalogId, ColorName) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...compdata,
        dis: 'Discontinue'
      })
    );
    fetch(`${globalIP}/api/mst-components/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchDatacomp();

        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleSaveRowComp = async () => {
    try {
      if (!component) {
        console.error('Component data not found.');
        return;
      }

      // Trim and validate component name
      const updatedColorName = component?.CompName?.trim() || '';
      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/

      if (!updatedColorName) {
        toaster.push(
          <Message showIcon type="error">Please enter Component Name.</Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      if (specialCharPattern.test(updatedColorName)) {
        toaster.push(
          <Message showIcon type="error">Component Name should not contain special characters.</Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      if (updatedColorName.startsWith(' ') || updatedColorName.endsWith(' ')) {
        toaster.push(
          <Message showIcon type="error">Component Name cannot start or end with a space.</Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // Check if component already exists
      const { data: updateComp } = await axios.get(
        `${globalIP}/api/mst-components?filters[CompName][$eqi]=${updatedColorName}&filters[id][$ne]=${editedRowIdComp}`
      );

      if (updateComp?.data?.length) {
        toaster.push(
          <Message showIcon type="warning">Component "{updatedColorName}" already exists.</Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // Update request with correct Strapi format
      const response = await fetch(`${globalIP}/api/mst-components/${editedRowIdComp}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          data: { ...component, CompName: updatedColorName },
        }),
      });

      // Handle response
      const result = await response.json();

      if (response.ok) {
        fetchDatacomp(); // Refresh data
        resetComponent('');
        setEditedRowIdComp('');
        setEditedDataComp(prevData => ({
          ...prevData,
          [editedRowIdComp]: { ...component, CompName: updatedColorName }, // Ensure UI updates correctly
        }));
        setEditedRowIdsComp(prevRowIds => [...new Set([...prevRowIds, editedRowIdComp])]);
      } else {
        console.error('Failed to update component:', result);
      }
    } catch (error) {
      console.error('Error occurred while saving data:', error);
    }
  };
  const handleInputChangeComp = (rowId, fieldName, value) => {
    setEditedDataComp(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...compdata.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };

  return (
    <>
      <Form.ControlLabel>
        <b>Component</b>
      </Form.ControlLabel>
      <Stack justifyContent="space-between" style={{ marginBottom: '10px' }} className="mstr-panel">
        <Stack spacing={160} className="mstr-panel1">
          <Input
            id="CompName"
            name="CompName"
            style={{ width: '180%' }}
            value={component && component.CompName ? component.CompName : ''}
            onChange={value => handleInputChangecomp('CompName', value, 0)}
            onPressEnter={submit13}
            className="mstr-btn"
            autoComplete="off"
            ref={processInputRef}
          />
          {editedRowIdComp ? (
            <Button
              appearance="primary"
              color="cyan"
              onClick={handleSaveRowComp}
              style={{ marginLeft: '10px' }}
            >
              {' '}
              Update
            </Button>
          ) : (
            <Button
              appearance="primary"
              color="cyan"
              onClick={submit13}
              style={{ marginLeft: '10px' }}
            >
              {' '}
              Add
            </Button>
          )}

        </Stack>
        <Stack className="mstr-search" spacing={5} style={{ marginLeft: '7px' }}>
          <SelectPicker
            data={data}
            placeholder="Status"
            labelKey="label"
            value={selectedBuyercomp}
            onChange={handleBuyerChangecomp}
            searchable={false}
            valueKey="value"
            size="md"
            appearance="default"
            style={{ width: 130 }}
            cleanable={false}
          />
          <InputGroup inside>
            <Input
              placeholder="Search"
              type="text"
              value={searchQuery13}
              onChange={handleSearch13}
            />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
        </Stack>
      </Stack>
      <Table
        rowHeight={60}
        data={componentFilterData}
        height={tableHeight}
        rowKey="id"
        bordered
        cellBordered
        loading={isLoading13}
      >
        <Table.Column width={60} fixed>
          <Table.HeaderCell>
            <b>Sr No.</b>
          </Table.HeaderCell>
          <Cell>{(_, rowIndex) => +rowIndex + 1}</Cell>
        </Table.Column>

        <Table.Column width={130} flexGrow={1}>
          <Table.HeaderCell>
            <b>Component Name</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              // editedRowIdsComp.includes(rowData.id) ? (
              //   <Input
              //     value={editedDataComp[rowData.id]?.CompName || ''}
              //     onChange={value => handleInputChangeComp(rowData.id, 'CompName', value)}
              //   />
              // ) : (
              rowData.attributes.CompName
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={100} fixed="right">
          <Table.HeaderCell>
            <b>Action</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              editedRowIdsComp.includes(rowData.id) ? (
                <div>
                  {/* <IconButton
                    size="sm"
                    icon={<CheckIcon />}
                    active
                    onClick={() => handleSaveRowComp(rowData.id)}
                    style={{ marginRight: '10px' }}
                  /> */}
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    active
                    onClick={handleCancelComponent}
                  // onClick={() =>
                  //   setEditedRowIdsComp(prevRowIds => prevRowIds.filter(id => id !== rowData.id))
                  // }
                  />
                </div>
              ) : (
                <div>
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowComp(rowData)}
                  />
                  {rowData.attributes.dis === 'Discontinue' ? (
                    <Popconfirm
                      title="Continue Component Name"
                      description="Are you sure you want to continue this Component Name?"
                      onConfirm={() => handleCompC(rowData.id, rowData.attributes.CompName)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Continue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<CheckRoundIcon />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handleCompC(rowData.id, rowData.attributes.CompName)}
                        />
                      </Whisper>
                    </Popconfirm>
                  ) : (
                    <Popconfirm
                      title="Discontinue Component Name"
                      description="Are you sure you want to discontinue this Component Name?"
                      onConfirm={() => handleCompD(rowData.id, rowData.attributes.CompName)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Discontinue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<ReviewPass />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handleCompD(rowData.id, rowData.attributes.CompName)}
                        />
                      </Whisper>
                    </Popconfirm>
                  )}
                </div>
              )
            }
          </Table.Cell>
        </Table.Column>
      </Table>
      <div>
        <p>
          <small>Total row:{componentFilterData.length}</small>
        </p>
      </div>
    </>
  );
};

export default CompNameMaster;
